module.exports = __webpack_public_path__ + "static/media/5.eb0d80c6.png";